module.exports = __webpack_public_path__ + "static/media/[Lectures_and_Panels]2014-02-05.05901184.md";